import { render, staticRenderFns } from "./time_ago_tooltip.vue?vue&type=template&id=20d4a48b"
import script from "./time_ago_tooltip.vue?vue&type=script&lang=js"
export * from "./time_ago_tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports